import { useQuery } from '@tanstack/react-query';
import { messageKeys } from '../messageKeys';
import { messagesService } from '../messagesService';

export function useUnreadConversationsCount() {
  return useQuery({
    queryKey: messageKeys.unreadCount(),
    queryFn: () => messagesService.getConversations({ page: 1, limit: 1, status: 'unread' }),
    select: (data) => data.unread,
    staleTime: 1000 * 60,
    gcTime: 1000 * 60 * 5,
    refetchOnWindowFocus: true,
  });
}
